import React from 'react';
import { PanelLeftClose, PanelLeftOpen } from 'lucide-react';
import './panel-toggle.css';

type PanelToggleProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  expanded: boolean;
};

/** A single visual language for revealing either level of navigation. */
export function PanelToggle({ expanded, className = '', ...props }: PanelToggleProps) {
  const Icon = expanded ? PanelLeftClose : PanelLeftOpen;
  return (
    <button
      type="button"
      {...props}
      className={`bsui-panel-toggle ${className}`.trim()}
      aria-expanded={expanded}
    >
      <Icon aria-hidden="true" size={18} strokeWidth={1.8} />
    </button>
  );
}
